"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils.ts";
import { Carousel, CarouselContent, CarouselItem } from "@repo/ui/carousel";
import { BannerColorBlock } from "../banner-color-block";
import type { BannerDataItem, BannerVariant } from "./general-banner.types";
import { getImage } from "./general-banner.utils";
import { BannerContentFader } from "./banner-content-fader.component";
export function BannerMulti(t0) {
  const $ = _c(15);
  const {
    banners,
    variant,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== banners) {
    t2 = banners.map(_temp);
    $[2] = banners;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <CarouselContent viewportClassName="h-full" className="h-full">{t2}</CarouselContent>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== banners || $[7] !== variant) {
    t4 = <BannerContentFader banners={banners} variant={variant} />;
    $[6] = banners;
    $[7] = variant;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="container-grid"><div className="col-span-full grid w-full grid-cols-1 tablet:grid-cols-2 overflow-hidden rounded-sm desktop:rounded-md desktop-lg:mx-auto">{t3}{t4}</div></div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <Carousel loop={true} duration={40}><section className={t1} data-testid="banner">{t5}</section></Carousel>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(item) {
  return <CarouselItem key={item._id} className="h-full"><div className="aspect-square h-full w-full overflow-hidden rounded-sm desktop:rounded-md"><div className="h-full w-full"><BannerColorBlock image={getImage(item)} maskedImage={item.maskedImage ?? undefined} colour={item.colour ?? undefined} className="aspect-auto h-full" /></div></div></CarouselItem>;
}